import { Action, AuthProvider } from '@/features/xac-thuc/components/action';

export function ViteAuthPage() {
  return (
    <AuthProvider>
      <Action />
    </AuthProvider>
  );
}
